<template>
  <div>
    <!-- capacitor deep link -->
  </div>
</template>

<script setup>
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

onMounted(() => {
  if (Capacitor.getPlatform() === 'ios') {
    // deep link
    App.addListener('appUrlOpen', (event) => {
      console.log('[Capacitor] App url open', event);
      try {
        const url = new URL(event.url);
        const fullPath = url.pathname + url.search;
        const currentFullPath = window.location.pathname + window.location.search;

        console.log('[Capacitor] Deep linking to path:', fullPath);

        // Navigate to the path
        if (fullPath && fullPath !== '/' && fullPath !== currentFullPath) {
          window.location.href = fullPath;
        }
      } catch (error) {
        console.error('[Capacitor] Error handling deep link:', error);
      }
    });
  }
});
</script>
